module.exports = __webpack_public_path__ + "images/aa7f5acaa6a031cbe1469afabb4ac7da.png";